import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock, renderList as _renderList, Fragment as _Fragment } from "vue";
const _hoisted_1 = {
  class: "flex flex-col gap-2"
};
const _hoisted_2 = {
  class: "h-7 flex items-center justify-between"
};
const _hoisted_3 = {
  class: "text-base pl-1"
};
const _hoisted_4 = {
  class: "flex items-center gap-2"
};
const _hoisted_5 = {
  class: "flex flex-col p-2 bg-white rounded-lg text-main-100 shadow-material text-xs"
};
const _hoisted_6 = {
  class: "h-10 flex items-center gap-4 px-3 mb-1"
};
const _hoisted_7 = {
  class: "flex items-center gap-2 ml-auto cursor-pointer"
};
const _hoisted_8 = {
  key: 0,
  class: "p-3 text-main-50 font-light"
};
const _hoisted_9 = {
  class: "w-full flex flex-col gap-1"
};
const _hoisted_10 = {
  class: "font-medium"
};
const _hoisted_11 = {
  key: 0,
  class: "flex items-center gap-2 [&_p]:truncate ml-auto"
};
const _hoisted_12 = ["onClick"];
const _hoisted_13 = {
  key: 0,
  class: "icon-cross-rounded text-lg text-red"
};
const _hoisted_14 = {
  key: 1,
  class: "icon-check-rounded text-lg text-second-100"
};
const _hoisted_15 = {
  class: "text-2xs whitespace-nowrap"
};
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  const _component_Button = _resolveComponent("Button");
  const _component_SimpleCheckbox = _resolveComponent("SimpleCheckbox");
  const _component_InputField = _resolveComponent("InputField");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createElementVNode("div", _hoisted_2, [_createElementVNode("p", _hoisted_3, _toDisplayString($props.data.label), 1), _createElementVNode("div", _hoisted_4, [$options.ItemsStatus.selected?.length ? (_openBlock(), _createBlock(_component_Button, {
    key: 0,
    variant: "outlined_light",
    size: "xs",
    icon: "icon-trash",
    class: "animate-fade",
    text: "Eliminar selección",
    onClick: _cache[0] || (_cache[0] = $event => $props.data.trashCallback($options.ItemsStatus.selected))
  })) : _createCommentVNode("", true)])]), _createElementVNode("div", _hoisted_5, [_createElementVNode("div", _hoisted_6, [_createVNode(_component_SimpleCheckbox, {
    modelValue: $options.ItemsStatus.allSelected,
    onClick: $options.ToggleSelected
  }, null, 8, ["modelValue", "onClick"]), _createVNode(_component_InputField, {
    variant: "default",
    size: "xs",
    icon: "icon-search",
    placeholder: "Nombre",
    class: "max-w-[200px]",
    modelValue: _ctx.searchKeyword,
    "onUpdate:modelValue": _cache[1] || (_cache[1] = $event => _ctx.searchKeyword = $event)
  }, null, 8, ["modelValue"]), _createElementVNode("div", _hoisted_7, [_cache[2] || (_cache[2] = _createElementVNode("p", null, "Último creado", -1)), _createElementVNode("i", {
    class: _normalizeClass(["icon-chevron-down text-base transition-transform", {
      'rotate-180': false
    }])
  })])]), !$options.FilteredItems?.length ? (_openBlock(), _createElementBlock("div", _hoisted_8, "No se han encontrado resultados")) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList($options.FilteredItems, item => {
    return _openBlock(), _createElementBlock("div", {
      key: item,
      class: "h-10 w-full flex items-center gap-4 px-3 bg-main-5/80 odd:bg-main-10/80"
    }, [_createVNode(_component_SimpleCheckbox, {
      modelValue: item.selected,
      "onUpdate:modelValue": $event => item.selected = $event,
      onClick: $event => item.selected = !item.selected
    }, null, 8, ["modelValue", "onUpdate:modelValue", "onClick"]), _createElementVNode("div", _hoisted_9, [_createElementVNode("p", _hoisted_10, _toDisplayString(item.title), 1)]), item.processed?.syncA3 ? (_openBlock(), _createElementBlock("div", _hoisted_11, _cache[3] || (_cache[3] = [_createElementVNode("p", {
      class: "text-2xs text-main-60"
    }, "Sincronizado con A3", -1), _createElementVNode("i", {
      class: "icon-check-rounded text-lg text-second-100"
    }, null, -1)]))) : _createCommentVNode("", true), item.processed?.syncSistemaRed ? (_openBlock(), _createElementBlock("div", {
      key: 1,
      class: _normalizeClass(["flex items-center gap-2 [&_p]:truncate ml-auto", {
        'cursor-pointer': item.lastError
      }]),
      onClick: $event => item.lastError ? this.$createToastMessage({
        text: item.lastError,
        type: 'error',
        alive: 3000,
        close: false,
        fixed: true
      }) : undefined
    }, [_cache[4] || (_cache[4] = _createElementVNode("p", {
      class: "text-2xs text-main-60"
    }, "Alta en Sistema Red", -1)), item.lastError ? (_openBlock(), _createElementBlock("i", _hoisted_13)) : (_openBlock(), _createElementBlock("i", _hoisted_14))], 10, _hoisted_12)) : _createCommentVNode("", true), _createVNode(_component_Button, {
      variant: "secondary",
      size: "xs",
      text: "Ver Alta",
      icon: "",
      loading: item.loading,
      onClick: $event => $props.data.openSubmissionCallback(item)
    }, null, 8, ["loading", "onClick"]), _createElementVNode("p", _hoisted_15, _toDisplayString(this.$formatDate({
      date: item.createdAt,
      format: 'dd/mm/yy hh:mm'
    })), 1)]);
  }), 128))])]);
}